import React, { useState, useEffect } from "react";

const SHIRT_IMAGE_MAP = {
  "Staff Shirt": "Staff-Shirt.jpg",
  "Grey Collar": "Grey-Collar.jpg",
  "Red Collar": "Grey-Collar.jpg",
  "Black Shirt": "Black-Shirt.jpg",
  "Green Collar": "Green-Collar.jpg",
  "Maintenance": "Maintenance-Shirt.jpg",
  "Maintenance Shirt": "Maintenance-Shirt.jpg",
  "GL Shirt": "GL-Shirt.jpg",
  "Driver Shirt": "Grey-Collar.jpg",
  "TL Shirt": "TL-Shirt.jpg",
};

const UniformImage = ({ imagesName, size, customSize }) => {
  const [imageSrc, setImageSrc] = useState("../images/UniformSurvey.png");

  useEffect(() => {
    if (!imagesName) return;

    const imagePath = "../images/uniformtype/";
    const defaultSrc = "../images/UniformSurvey.png";

    const filename = SHIRT_IMAGE_MAP[imagesName]
      || `${imagesName.replace(/\s+/g, "-")}.jpg`;
    const finalImageSrc = `${imagePath}${filename}`;

    const img = new Image();
    img.src = finalImageSrc;
    img.onload = () => setImageSrc(finalImageSrc);
    img.onerror = () => {
      setImageSrc(defaultSrc);
    };
  }, [imagesName]);

  const imageClass =
    size === "sm"
      ? "m-2 rounded item-shadow border"
      : "m-2 mb-2 rounded w-100 border rounded";

  return (
    <img
      src={imageSrc}
      alt={imagesName || "Uniform Survey"}
      className={imageClass}
      width={customSize || (size === "sm" ? 45 : undefined)}
    />
  );
};

export default UniformImage;
